export const Plans={
  "awesome-yearly":{
    name:"Awesome",
    id:"awesome-yearly",
    price:"99.99",
    period:"year",
    accounts:2,
    collaborators:2
  },
  "business-yearly":{
    name:"Business",
    id:"business-yearly",
    price:"299.99",
    period:"year",
    accounts:6,
    collaborators:10
  },
  "test-day":{
    name:"Test Day",
    id:"test-day",
    price:"9.99",
    period:"year",
    accounts:2,
    collaborators:2
  },
  "awesome-monthly":{
    name:"Awesome",
    id:"awesome-monthly",
    price:"9.99",
    period:"month",
    accounts:2,
    collaborators:2
  },
  "business-monthly":{
    name:"Business",
    id:"business-monthly",
    price:"29.99",
    period:"month",
    accounts:6,
    collaborators:10
  },
  "10-accounts-monthly":{
    name:"10 Accounts",
    id:"10-accounts-monthly",
    price:"49.99",
    period:"month",
    accounts:10,
    collaborators:10
  },
  "15-accounts-monthly":{
    name:"15 Accounts",
    id:"15-accounts-monthly",
    price:"74.99",
    period:"month",
    accounts:15,
    collaborators:10
  },
  "20-accounts-monthly":{
    name:"20 Accounts",
    id:"20-accounts-monthly",
    price:"99.99",
    period:"month",
    accounts:20,
    collaborators:10
  },
  "30-accounts-monthly":{
    name:"30 Accounts",
    id:"30-accounts-monthly",
    price:"149.99",
    period:"month",
    accounts:30,
    collaborators:10
  },
  "10-accounts-yearly":{
    name:"10 Accounts",
    id:"10-accounts-yearly",
    price:"499.9",
    period:"year",
    accounts:10,
    collaborators:10
  },
  "15-accounts-yearly":{
    name:"15 Accounts",
    id:"15-accounts-yearly",
    price:"749.99",
    period:"year",
    accounts:15,
    collaborators:10
  },
  "20-accounts-yearly":{
    name:"20 Accounts",
    id:"20-accounts-yearly",
    price:"999.99",
    period:"year",
    accounts:20,
    collaborators:10
  },
  "30-accounts-yearly":{
    name:"30 Accounts",
    id:"30-accounts-yearly",
    price:"1499.99",
    period:"year",
    accounts:30,
    collaborators:10
  }
}

export default {
  "normal": {
    "yearly":{
      "awesome":Plans["awesome-yearly"],
      "business":Plans["business-yearly"],
      "test-day":Plans["test-day"]
    },
    "monthly":{
      "awesome":Plans["awesome-monthly"],
      "business":Plans["business-monthly"],
      "test-day":Plans["test-day"]
    },
  },
  custom: {
    "monthly":{
      "10-accounts":Plans["10-accounts-monthly"],
      "15-accounts":Plans["15-accounts-monthly"],
      "20-accounts":Plans["20-accounts-monthly"],
      "30-accounts":Plans["30-accounts-monthly"]
    },
    "yearly":{
      "10-accounts":Plans["10-accounts-yearly"],
      "15-accounts":Plans["15-accounts-yearly"],
      "20-accounts":Plans["20-accounts-yearly"],
      "30-accounts":Plans["30-accounts-yearly"]
    }

  }
}



// WEBPACK FOOTER //
// ./src/shared/plans.js